import type { CityConfig } from "../city-template/types";

export const daytonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Dayton",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "dayton",
  route: "/cities/dayton",
  title: "Emergency Passport Dayton, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Dayton, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Montgomery County and the Dayton metro area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Dayton, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Dayton and Greater Dayton metro area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dayton%20Ohio%20downtown%20skyline%20at%20sunset%20with%20the%20beautiful%20Great%20Miami%20River%20waterfront%2C%20historic%20buildings%20and%20modern%20architecture%20bathed%20in%20warm%20golden%20orange%20light%2C%20riverfront%20parks%20and%20walking%20paths%20visible%2C%20clear%20evening%20sky%20with%20vibrant%20colors%20reflecting%20on%20the%20river%2C%20professional%20cityscape%20photography%20wide%20panoramic%20view%2C%20vibrant%20Midwest%20city%20scene&width=1800&height=700&seq=dayton-hero-oh-001&orientation=landscape",
  heroImageAlt: "Dayton Ohio downtown skyline at sunset with the Great Miami River waterfront",
  geoPosition: "39.7589;-84.1916",
  geoPlacename: "Dayton, Ohio",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 310 miles, 4.5 hours via I-70",
  },
  lastModified: "2026-06-14",
  nearbyCitiesZips: [
    { name: "Dayton", zips: "45401–45458" },
    { name: "Kettering", zips: "45419, 45420, 45429, 45440" },
    { name: "Beavercreek", zips: "45430, 45431, 45432, 45434" },
    { name: "Centerville", zips: "45458, 45459" },
    { name: "Fairborn", zips: "45324" },
    { name: "Huber Heights", zips: "45424" },
    { name: "Miamisburg", zips: "45342" },
    { name: "Springboro", zips: "45066" },
    { name: "Troy", zips: "45373, 45374" },
    { name: "Vandalia", zips: "45377" },
    { name: "Trotwood", zips: "45426" },
    { name: "Xenia", zips: "45385" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Dayton departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-flight-takeoff-line", title: "Airport Proximity", desc: "Serving DAY and CMH travelers across the Miami Valley" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Cincinnati, OH", route: "/cities/cincinnati" },
    { name: "Fast passport renewal in Columbus, OH", route: "/cities/columbus-oh" },
    { name: "Emergency passport help in Cleveland, OH", route: "/cities/cleveland" },
    { name: "Urgent passport services in Kettering, OH", route: "/cities/kettering" },
    { name: "Same-day passport help in Beavercreek", route: "/cities/beavercreek" },
    { name: "Passport courier services in Springfield", route: "/cities/springfield-oh" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Dayton remotely via secure courier. We do not have a walk-in office in Dayton — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Montgomery County and Miami Valley travelers.",
  fpcOfficeAddress: "312 Walnut St, Cincinnati, OH 45202",
  fpcOfficeDistance: "Serving all of Montgomery County and the greater Miami Valley region",
  serviceAreaIntro: "From downtown Dayton to the suburbs of Kettering, Beavercreek, and Centerville, from Wright-Patterson AFB to Springboro — Fast Passport Center serves the entire Greater Dayton metro area. We regularly help travelers from Fairborn, Huber Heights, and Miamisburg get their passports fast.",
  nearbyCitiesIntro: "We serve all Dayton neighborhoods and surrounding Miami Valley cities including Kettering, Beavercreek, Centerville, Fairborn, Huber Heights, Miamisburg, Springboro, Troy, Vandalia, Trotwood, Xenia, and beyond. If you are anywhere in Montgomery, Greene, Warren, or Miami counties, we have you covered.",
  howItWorksIntro: "Most Dayton travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Dayton travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Dayton and Miami Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Dayton? Here are the most common ones we hear from Montgomery County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  vitalRecordsLinks: [
    { icon: "ri-user-heart-line", label: "Birth Certificates — Ohio Department of Health", desc: "Request certified Ohio birth certificates from the ODH Bureau of Vital Statistics. Available by mail, online, or in person at the Columbus office.", url: "https://odh.ohio.gov/know-our-programs/vital-statistics" },
    { icon: "ri-file-history-line", label: "Death Certificates — Ohio Department of Health", desc: "Obtain certified Ohio death certificates through ODH Vital Statistics. Mail, online, and in-person options available.", url: "https://odh.ohio.gov/know-our-programs/vital-statistics" },
    { icon: "ri-hearts-line", label: "Marriage Certificates — Montgomery County Probate Court", desc: "Marriage licenses and certified copies available through the Montgomery County Probate Judge at 41 N Perry St, Dayton, OH 45422.", url: "https://www.mcohio.org/probate-court" },
    { icon: "ri-file-copy-2-line", label: "Divorce Records — Montgomery County Clerk of Courts", desc: "Certified divorce decrees available from the Montgomery County Clerk of Courts at 41 N Perry St, Dayton, OH 45422.", url: "https://www.mcohio.org/court-clerk" },
    { icon: "ri-global-line", label: "Order Online — VitalChek", desc: "Order Ohio birth, death, marriage, and divorce certificates online through VitalChek, the official partner of the Ohio Department of Health. Fastest online option.", url: "https://www.vitalchek.com/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Dayton international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Michael A.",
      location: "Dayton, OH",
      rating: 5,
      text: "Needed a passport renewal fast for a last-minute trip to Germany. Fast Passport Center delivered in 4 business days. The whole process was smooth and stress-free.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah B.",
      location: "Beavercreek, OH",
      rating: 5,
      text: "My husband is stationed at Wright-Patterson and we needed emergency passports for a family trip. These guys came through in 36 hours. Outstanding service.",
      service: "Emergency Passport",
    },
    {
      name: "Tom F.",
      location: "Kettering, OH",
      rating: 5,
      text: "First passport for our honeymoon to Mexico. Fast Passport Center made the entire process easy and delivered in 5 days. Would absolutely use again.",
      service: "New Passport",
    },
    {
      name: "Lisa C.",
      location: "Centerville, OH",
      rating: 5,
      text: "Our daughter needed a passport for a study abroad semester with only 10 days' notice. They expedited it in 4 days. Saved our daughter's semester abroad!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "dayton-1",
      name: "Dayton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1111 E 5th St",
      city: "Dayton",
      state: "OH",
      zip: "45401",
      phone: "(937) 227-8333",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Dayton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Dayton facility. Appointments recommended. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "dayton-2",
      name: "Kettering Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3500 Marshall Rd",
      city: "Kettering",
      state: "OH",
      zip: "45429",
      phone: "(937) 296-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Dayton suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Kettering, Centerville, and Oakwood residents. Typically less crowded than downtown.",
      icon: "ri-mail-line",
    },
    {
      id: "dayton-3",
      name: "Beavercreek Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3095 Dayton-Xenia Rd",
      city: "Beavercreek",
      state: "OH",
      zip: "45431",
      phone: "(937) 426-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Dayton suburb near Wright-Patterson AFB",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Beavercreek, Fairborn, and Wright-Patterson AFB residents.",
      icon: "ri-mail-line",
    },
    {
      id: "dayton-4",
      name: "Huber Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6080 Chambersburg Rd",
      city: "Huber Heights",
      state: "OH",
      zip: "45424",
      phone: "(937) 233-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Dayton suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Huber Heights, Vandalia, and north Dayton area. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "dayton-5",
      name: "Montgomery County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "41 N Perry St",
      city: "Dayton",
      state: "OH",
      zip: "45422",
      phone: "(937) 225-4575",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Dayton, near courthouse square",
      website: "https://www.mcohio.org/court-clerk",
      websiteLabel: "Montgomery County Courts",
      notes: "Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "dayton-6",
      name: "Springboro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "395 N Main St",
      city: "Springboro",
      state: "OH",
      zip: "45066",
      phone: "(937) 748-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Dayton, Warren County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Springboro, Miamisburg, and Centerville residents. Less wait than downtown.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 310-mile, 4.5-hour drive to Chicago via I-70", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Wright-Patterson AFB Support", agency: "No military family expertise", fpc: "Yes — military family and deployment knowledge" },
    { feature: "Photo & Document Help", agency: "No guidance provided", fpc: "Yes — full document review included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Dayton photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or wrong form type are the #1 rejection reasons at Montgomery County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Dayton applicants arrive with incorrect payment and must reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or provide notarized consent. This is a frequent issue for military families at Wright-Patterson.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Dayton travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Dayton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Dayton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Dayton before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Dayton for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround without the long drive to Chicago." },
    { q: "How fast can I renew my passport in Dayton?", a: "Fast Passport Center offers fast passport renewal in Dayton in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "I am stationed at Wright-Patterson AFB — can you help with military passports?", a: "Yes. Fast Passport Center helps military families stationed at Wright-Patterson AFB and throughout the Miami Valley with expedited passport services. We understand military travel orders and deployment timelines, and we work to meet your requirements as efficiently as possible." },
    { q: "What is the closest passport agency to Dayton?", a: "The nearest regional passport agency to Dayton is the Chicago Passport Agency, approximately 325 miles away via I-70. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Dayton without any agency visit required." },
    { q: "Can I get a same-day passport appointment near Dayton?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Montgomery County residents." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Downtown Dayton", address: "20 W 4th St, Dayton, OH 45402", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Kettering", address: "3640 Marshall Rd, Kettering, OH 45429", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Dayton", address: "1 W Schantz Ave, Dayton, OH 45409", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/default/office" },
    { name: "Walmart Supercenter — Beavercreek", address: "3360 Seajay Dr, Beavercreek, OH 45430", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/cp/photo/1078904" },
    { name: "CVS Pharmacy — Huber Heights", address: "6261 Chambersburg Rd, Huber Heights, OH 45424", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Centerville", address: "100 E Franklin St, Centerville, OH 45459", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Springboro", address: "405 N Main St, Springboro, OH 45066", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "AAA Travel — Dayton", address: "1800 E Stroop Rd, Kettering, OH 45429", hours: "Mon–Fri: 8AM–5:30PM", website: "https://www.aaa.com/travel" },
  ],
  dmvLocations: [
    {
      name: "Montgomery County BMV — Dayton",
      address: "1435 Cincinnati St, Dayton, OH 45417",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Greene County BMV — Beavercreek",
      address: "2121 Dayton-Xenia Rd, Beavercreek, OH 45434",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Beavercreek and Fairborn residents. REAL ID available.",
      featured: false,
    },
    {
      name: "Montgomery County BMV — Kettering",
      address: "3750 Kettering Blvd, Kettering, OH 45439",
      hours: "Mon–Fri: 8AM–5PM",
      note: "South suburban option. Typically shorter wait times.",
      featured: true,
    },
    {
      name: "Warren County BMV — Springboro",
      address: "210 Beal Dr, Franklin, OH 45005",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Springboro, Miamisburg, and Franklin area residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DAY",
      name: "Dayton International Airport",
      distance: "15 miles north of downtown Dayton",
      address: "3600 Terminal Dr, Dayton, OH 45377",
      note: "Primary airport serving the Greater Dayton area. Good domestic connections with less congestion than major hubs.",
      flightUrl: "https://flydayton.com/",
      flightLabel: "DAY Airport",
      featured: true,
    },
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International Airport",
      distance: "65 miles southwest of Dayton",
      address: "3087 Terminal Dr, Hebron, KY 41048",
      note: "Major international hub. Delta connections to Europe and beyond. Worth considering for international flights.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Airport",
      featured: false,
    },
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "70 miles northeast of Dayton",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Larger hub with broader international routes. Consider for long-haul international trips.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "Columbus Airport",
      featured: false,
    },
  ],
};